<template>
  <div class="home">
      <!-- 顶部 -->
      <div class="top">
          <div class="logoimg">
            <div style=" display: flex; justify-content: center;align-items: center;">
              <img class="leftLogo" src="../img/顶部logo.png" alt="">
            </div>
            <div >
              <img class="phone" src="../img/右上logo.png" alt="">
            </div>
          </div>
      </div>
      <!-- tab栏 -->
      <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      @select="handleJump"
      background-color="#FABE03"
      text-color="#fff"
      active-text-color="black"
      >
        <el-menu-item  :class="{'active-background': activeIndex === '1'}" index="1" class="txt">网站首页</el-menu-item>
        <el-submenu :class="{'active-background': activeIndex.includes('2-')}" index="2">
          <template slot="title">
            <div :class="{'active-background': activeIndex.includes('2-')}" class="txt01">课程介绍</div>
          </template>
          <el-menu-item v-for="item in secondMenu" :key="item.key" :index="item.key">{{ item.name }}</el-menu-item>
        </el-submenu>
        <el-menu-item :class="{'active-background': activeIndex === '3'}" index="3" class="txt" >师资团队</el-menu-item>
        <el-menu-item :class="{'active-background': activeIndex === '4'}" index="4" class="txt" >联系我们</el-menu-item>
      </el-menu>
      <component :is="componentId" ref="operateConfig"></component>
      <!-- 首页展示内容 -->
      <div v-if="activeIndex==='1'">
        <!-- 轮播图 -->
        <el-carousel :interval="5000" class="ban">
          <el-carousel-item
          v-for="(item, index) in arr"
          :key="index"
          class="ban">
            <img class="img-item" :src="item.imgUrl" alt="">
          </el-carousel-item>
        </el-carousel>
        <!-- 商品详情 -->
        <div class="goods">
          <div class="jieshao">
            <h6 class="title">
              符合市场需求的课程体系
              <div class="eng">Course</div>
            </h6>
          </div>
          <div class="teach">
              <div class="boxone" v-for="item in secondMenu" :key="item.key">
                <div><img class="pic" :src=item.img alt=""></div>
                <div class="teatxt">{{ item.name }}</div>
                <div class="stutxt">课程简介:</div>
                <div class="txts">{{ item.desc }}</div>
                <el-button class="button" type="warning" @click="handleJump(item.key)">查看课程</el-button>
              </div>
          </div>
        </div>
        <!-- 教育资源 -->
        <div class="goodss">
          <h6 class="title" style="color: #000;">
            师资汇聚，实战经验倾囊相授
            <div class="eng">Team</div>
          </h6>
          <div>
            <img class="teacher" src="../img/newteacher.jpg" alt="">
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="down">
        <div class="logos">
          <div style="display: flex; margin-bottom: 50px">
            <div class="bottom-menu" @click="handleJump('1')">关于我们&nbsp;&nbsp;|</div>
            <div class="bottom-menu" @click="handleJump('2-1')">&nbsp;&nbsp;课程介绍&nbsp;&nbsp;|</div>
            <div class="bottom-menu" @click="handleJump('3')">&nbsp;&nbsp;师资团队&nbsp;&nbsp;|</div>
            <div class="bottom-menu" @click="handleJump('4')">&nbsp;&nbsp;联系我们</div>
          </div>
          <div class="address">
            地址:北京市海淀区永润路18号院5幢-1层107-25
          </div>
          <div style="font-size: 16px;">
            服务备案号:
            <img style="width: 30px; height: 30px;" src="../img/beian.png" alt="">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=11010802045268" rel="noreferrer" target="_blank">京公网安备11010802045268</a>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import HuaBuChe from './components/HuaBuChe.vue'
import TiaoSheng from './components/TiaoSheng.vue'
import BasketBall from './components/BasketBall.vue'
import GymNastics from './components/GymNastics.vue'
import ParkOur from './components/ParkOur.vue'
import RunNing from './components/RunNing.vue'
import TeacherTeam from './components/TeacherTeam.vue'
import CallMe from './components/CallMe.vue'

export default {
  components: {
    HuaBuChe,
    TiaoSheng,
    BasketBall,
    GymNastics,
    RunNing,
    ParkOur,
    TeacherTeam,
    CallMe
  },
  data () {
    return {
      secondMenu: [
        { key: '2-1', name: '平衡车体能', img: require('../img/滑步车.jpg'), desc: '适合2-5岁儿童,通过滑步车的练习可以促进儿童的动作发展,锻炼平衡稳定性,促进大脑对身体的协调控制能力,提高孩子的反应速度。' },
        { key: '2-2', name: '跳绳体能', img: require('../img/跳绳.jpg'), desc: '跳绳课是面对幼儿园中大班和小学阶段的学生,适合4.5-12岁儿童,帮助学生从零基础学会跳绳,提高跳绳的考试成绩。采取小班制教学,针对性训练更强。' },
        { key: '2-3', name: '篮球启蒙课程', img: require('../img/篮球.jpg'), desc: '篮球课程能激发儿童对运动的主动性和积极性。帮助孩子锻炼身体,积极建立儿童团结合作、竞争对抗的的体育精神。' },
        { key: '2-4', name: '综合体能', img: require('../img/体能.jpg'), desc: '主要锻炼儿童的力量、平衡感、空间感、身体形态气质。体操技能的形成能极大的提高儿童自信心！' },
        { key: '2-5', name: '安防课程', img: require('../img/安防.jpg'), desc: '树立孩子的安全与防卫意识，防霸凌与防诱拐；培养孩子的坚毅品格。' },
        { key: '2-6', name: '跑酷体能', img: require('../img/跑酷.jpg'), desc: '跑酷是运动素质速度、力量、爆发力、灵敏性等的外在表现。增加儿童对运动的自主性和积极性。' }
      ],
      componentName: {
        '2-1': HuaBuChe,
        '2-2': TiaoSheng,
        '2-3': BasketBall,
        '2-4': GymNastics,
        '2-5': RunNing,
        '2-6': ParkOur,
        3: TeacherTeam,
        4: CallMe
      },
      componentId: '',
      activeIndex: '1',
      backgroundColor: '',
      arr: [
        { imgUrl: require('../img/gun1.jpg') },
        { imgUrl: require('../img/gun2.jpg') },
        { imgUrl: require('../img/gun3.jpg') }
      ]
    }
  },
  methods: {
    handleJump (key, keyPath) {
      this.activeIndex = key
      this.componentId = this.componentName[this.activeIndex]
    }
  }
}
</script >

<style >
   body{
    margin: 0
  }
  /* 顶部 */
  .top{
    height: 135px;
    /* background-color: #FABE03; */
  }
  .leftLogo{
    width: 650px;
    height: 200px;
  }
  .logoimg{
    width: 1210px;
    height: 135px;
    margin:0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .phone{
    width: 500px;
    height: 200px;
  }
  .callme{
    padding-top: 5px;
    display: inline;
  }
  .callphone{
    font-weight: 700;
  }
  .call{
    font-size: 32px;
    font-weight: 700;
    color: #EB2F2F;
  }
  .imgg{
    width: 180px;
    height: 135px;
  }
  .imggg{
    width: 100px;
    height: 100px;

  }
  .el-icon-phone{
    margin-top: 30px  ;
    font-size: 67px;
  }
  /* tab */
  .el-menu-demo{
    display: flex;
    justify-content: space-evenly;
    color: red;
    /* background-color:  #FABE03; */
  }
  .tab{
    display: flex;
    height: 60px;
    background-color: pink;
  }
  .tabbox{
    width: 104px;
    height: 60px;
    background-color: skyblue;
  }
  .txt{
    font-size: 16px;
  }
  .txt01 {
      font-size: 16px;
      padding: 0 20px;
    }
  :deep .el-submenu__title {
    padding: 0 !important;
  }
  .el-submenu__title{
    padding: 0 !important;
  }
  .active-background{
    /* background-color: #2c3e50 !important; */
    background-color: black !important;
    color:#FFF!important;
  }
  /* 广告 */
  .ban{
    height: 515px;
  }
  .img-item {
    width: 100%;
    height: 100%;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 515px;
    margin: 0;
  }
  .el-carousel__container{
    height: 515px;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  /* 商品 */
  .goods{
    width: 1210px;
    height: 1486px;
    margin:0 auto;
    margin-top: 100px;
  }
  .jieshao{
    height: 170px;
  }
  .title{
    height: 150px;
    font-size: 38px;
    padding-top: 40px;
    padding-bottom: 25px;
    margin: 0 0 0 0;
    text-align: center;
  }
  .eng{
    font-size: 16px;
    margin-top: 20px;
  }
  .teach {
    display: flex;
    flex-wrap: wrap;
  }
  .boxone{
    width: 1210px;
    justify-content: space-evenly;
    width: 355px;
    margin-right: 40px;
    margin-bottom: 20px;
    background-color: #fff;
  }
  .pic{
    width: 100%;
    height: 100%;
    background-color: skyblue;
  }
  .teatxt{
    text-align: center;
    margin-top: 20px;
    font-size: 18px;
    font-weight: 700;
  }
  .stutxt{
    margin-top: 20px;
    font-size: 14px;
    font-weight: 700;
  }
  .txts{
    font-size: 14px;
  }
  .button{
    margin: 30px 0 0 120px;
  }
  /* 教育资源 */
  .teacher{
    width: 1210px;
    height: 650px ;
  }
  .goodss{
    width: 1210px;
    margin:0 auto;
    padding-bottom: 80px;
  }
  /* 底部 */
  .down{
    width: 100%;
    height: 330px;
    background-color: #FABE03;
    display: flex;
    justify-content: space-evenly;
    background-image: url(../img/底图.jpg);
  }
  .logos{
    font-family: 'SimHei';
    font-size: 20px;
    font-weight: 700;
    padding: 110px 0 0 0;
    margin-left: 900px
  }
  .address{
    margin-bottom: 50px;
    font-size: 16px;
  }
  a {
  text-decoration: none;
  color: blue;
  font-size: 16px;
}
</style>
